"use client";

import { useState } from "react";
import { Mail, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [language, setLanguage] = useState<"ja" | "en">("ja");
  const toggleLanguage = () => {
    setLanguage(prev => prev === "ja" ? "en" : "ja");
  };
  if (loading) {
    return <header className="fixed top-0 left-0 right-0 z-50 bg-background border-b border-primary/20 shadow-soft">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <div className="h-10 w-40 bg-muted animate-pulse rounded-md" />
            <div className="flex gap-2">
              <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
              <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
              <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
            </div>
            <div className="flex gap-4">
              <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
              <div className="size-5 bg-muted animate-pulse rounded-md" />
              <div className="size-5 bg-muted animate-pulse rounded-md" />
            </div>
          </div>
        </div>
      </header>;
  }
  return <header className="fixed top-0 left-0 right-0 z-50 bg-background border-b border-primary/20 shadow-soft">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {}
          <div className="animate-fade-in-up">
            <Link to="/HomePage">
              <img src="https://nhatminhkhang.com/wp-content/uploads/2026/01/Artboard-1-copy@2x-100-0123.png" alt="Nhật Minh Khang & Partners" className="h-10" />
            </Link>
          </div>

          {}
          <NavigationMenu viewport={false}>
            <NavigationMenuList>
              {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i} className="animate-fade-in-up" style={{
              animationDelay: `${(i + 1) * 150}ms`
            }}>
                  <NavigationMenuLink asChild>
                    <Link to={item.href || "#"} className="relative px-3 py-2 text-sm font-medium text-foreground hover:text-primary transition-colors duration-[var(--duration-medium)] group">
                      {item.label}
                      <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary scale-x-0 group-hover:scale-x-100 group-data-[active=true]:scale-x-100 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] origin-left" />
                    </Link>
                  </NavigationMenuLink>
                </NavigationMenuItem>)}
            </NavigationMenuList>
          </NavigationMenu>

          {}
          <div className="flex items-center gap-4">
            <button onClick={toggleLanguage} className="animate-fade-in-up px-3 py-1.5 text-sm font-medium bg-secondary text-foreground-secondary rounded-md hover:bg-secondary-hover transition-all duration-[var(--duration-medium)] hover:shadow-soft focus-ring" style={{
            animationDelay: "600ms"
          }}>
              {language === "ja" ? "EN" : "日本語"}
            </button>

            <Link to="mailto:Contact email to be provided" className="animate-fade-in-up text-foreground hover:text-primary transition-all duration-[var(--duration-medium)] hover:scale-110 focus-ring rounded-md p-1" style={{
            animationDelay: "750ms"
          }} aria-label="Email">
              <Mail className="size-5" />
            </Link>

            <Link to="tel:Contact number to be provided" className="animate-fade-in-up text-foreground hover:text-primary transition-all duration-[var(--duration-medium)] hover:scale-110 focus-ring rounded-md p-1" style={{
            animationDelay: "900ms"
          }} aria-label="Phone">
              <Phone className="size-5" />
            </Link>
          </div>
        </div>
      </div>
    </header>;
}
export default function Header() {
  return <MenuProvider menu_id="3">
      <HeaderMenuConsumer />
    </MenuProvider>;
}